import { useState, useEffect } from "react";
import { fetchTestReports } from "../services/fetchTestReports";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function useFetchTestReports() {
  const [testReports, setTestReports] = useState([]);
  const [loading1, setLoading1] = useState(true);
  const { auth, setCommonWarning, breadcrumbs } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadTestReports = async () => {
      try {
        const topic =
          breadcrumbs.find((item) => item.path === "/subtopics")?.id || null;
        const data = await fetchTestReports(auth.token, topic);

        if (data.status === 200) {
        //   console.log("Fetched Test Reports Data:", data);
          const fldt = data.data.data;
          const fnldata = fldt.map((report) => ({
            id: report.id,
            title: report.title,
            outcomes: report.outcomes,
            reports: report.reports,
          }));
          //   console.log("Fetched Test Reports:", fnldata);
          setTestReports(fnldata);
        } else if (data.status === 400) {
          setCommonWarning(data.message);
        } else if (data.status === 401) {
          navigate("/login");
          return []; // return empty if unauthorized
        }
        setLoading1(false);
      } catch (error) {
        console.error("Error fetching levels:", error);
      }
    };
    loadTestReports();
  }, [auth, breadcrumbs, setCommonWarning]);

  return [testReports, loading1];
}

export default useFetchTestReports;
